import { Table } from 'antd';
import React, { useEffect,useState } from 'react';

import defaultConfig from './config';

export default function TableData(props){

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ pageSize: 10 });

  useEffect(() => {
    setPagination(
      {
        ...pagination,
        current: 1
      }
    );
  }, [props.reload]);

  useEffect(() => {
    actionGetData({ ...props });
  }, [props.paramSearch]);

  useEffect(() => {
    setData([]);
    setLoading(false);
    setPagination({ pageSize: 10 })
  }, [props.clear]);

  const handleTableChange = (paginationConfig) => {
    actionGetData(props, { page: paginationConfig.current });
  };

  const actionGetData = async (componentProps, { page } = { pageSize: 10 }) => {
    const {
      allowGetData,
      paramSearch,
      service,
      handleGetDataResponse,
      getPageIndexForSevice,
    } = componentProps;
    if (!service) {
      return;
    }
    if (loading || !allowGetData) {
      return;
    }

    setLoading(true);

    try {
      const res = await service({
        page: getPageIndexForSevice(page) || 0,
        size: pagination.pageSize,
        ...paramSearch,
      });
      const { content, total } = handleGetDataResponse(res);
      const updatingPagination = { ...pagination };
      updatingPagination.total = total;
      updatingPagination.current = page;
      setData(content);
      setPagination(updatingPagination);
    } finally {
      setLoading(false);
    }
  };


  return (
    <Table
      bordered
      scroll={props.disableScroll ? undefined : { x: true }}
      loading={loading}
      pagination={pagination}
      onChange={handleTableChange}
      dataSource={data}
      columns={props.columns}
      {...props}
    />
  );
}

TableData.defaultProps = {
  allowGetData: true,
  ...defaultConfig
}